export default __webpack_public_path__ + "static/media/check.3a9b4d90.png";